module.exports = __webpack_public_path__ + "icon-canjs.3uf3SLE7.svg";